import { numberFormat } from 'shared/constants.json';

const identityAffix = (value) => value;

const AFFIX_BY_FORMAT = {
  [numberFormat.percent]: (value) => `${value}%`,
  [numberFormat.dollar]: (value) => `$${value}`,
  [numberFormat.euro]: (value) => `${value}€`,
  [numberFormat.pound]: (value) => `£${value}`,
};

export const numberFormatAffix = (format) => AFFIX_BY_FORMAT[format] ?? identityAffix;

export const numberFormatter = (format, locale) => {
  const options = { style: 'decimal' };
  switch (format) {
    case numberFormat.number:
      options.useGrouping = false;
      // maximumFractionDigits cannot be disabled, so we set it to 20
      options.maximumFractionDigits = 20;
      break;
    case numberFormat.percent:
    case numberFormat.dollar:
    case numberFormat.euro:
    case numberFormat.pound:
      options.maximumFractionDigits = 2;
      break;
    case numberFormat.commaSeparated:
    default:
      break;
  }
  const affix = numberFormatAffix(format);
  return (value) => {
    if (value === null) {
      return null;
    }
    return affix(new Intl.NumberFormat(locale, options).format(value));
  };
};

export const numberParser = (format, locale) => {
  let valueAdjuster = (value) => value;
  switch (format) {
    case numberFormat.percent:
      valueAdjuster = (value) => `${value}`.replace('%', '');
      break;
    case numberFormat.dollar:
      valueAdjuster = (value) => `${value}`.replace('$', '');
      break;
    case numberFormat.euro:
      valueAdjuster = (value) => `${value}`.replace('€', '');
      break;
    case numberFormat.pound:
      valueAdjuster = (value) => `${value}`.replace('£', '');
      break;
    case numberFormat.number:
    case numberFormat.commaSeparated:
    default:
      break;
  }
  return (value) => parseLocaleNumber(valueAdjuster(value), locale);
};

/**
 * Parse a localized number to a float.
 * @param {string} stringNumber - the localized number
 * @param {string} locale - [optional] the locale that the number is represented in. Omit this parameter to use the current locale.
 */
const parseLocaleNumber = (stringNumber, locale) => {
  const formatter = new Intl.NumberFormat(locale);
  const thousandSeparator = formatter.formatToParts(11111)[1].value;
  const decimalSeparator = formatter.formatToParts(1.1)[1].value;

  return parseFloat(stringNumber
    .replace(new RegExp(`\\${thousandSeparator}`, 'g'), '')
    .replace(new RegExp(`\\${decimalSeparator}`), '.'));
};
